module.exports = __webpack_public_path__ + "img/powerImg1.37091789.jpg";